import React from 'react';
import { Modal, Form } from 'react-bootstrap';
// import { FaCheck } from 'react-icons/fa';
import { IoIosCloseCircle } from 'react-icons/io';

const AddMachineStatus = ({
  equipmentList,

  handleAddMachineStatusClick,

  // handleItemClick,
  handleCloseModal
}) => {
  return (
    <div className='scheduleForm'>
      {/* Header */}
      <Modal.Header className="flex-column align-items-center text-center mb-2">
        <Modal.Title>Add Machine Status</Modal.Title>
    
        <div className="cross-close" onClick={handleCloseModal}>
          <IoIosCloseCircle />
        </div>
      </Modal.Header>

      {/* Body */}
      <Modal.Body>
        <Form.Label className="sm-1">Equipment</Form.Label>
        <div className="equipment-list-wrapper">
          {equipmentList?.map((item) => {
           // const isSelected = selectedItems?.includes(item?.id);

            return (
              <div
                key={item?.id}
                className={`equipment-item d-flex justify-content-between py-2 me-2 border-bottom`}>
                <div className="equipment-info">
                  <div className="text-muted small">{item?.equipment_name}</div>

                  {/* Error or overlap messages inline under name */}
                  {!item?.is_machine_status_level_set && (
                    <small className="text-danger">
                      No limits found in machine status.{' '}
                      <span
                        className="text-primary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleAddMachineStatusClick(item)}>
                        Click here to add them.
                      </span>
                    </small>
                  )}

                  {item?.is_schedule_overlapped && (
                    <small className="text-danger">
                      There is a schedule overlap for this equipment (
                      {item?.overlapped_schedule_name}). Adding it here will remove it from the
                      other schedule.
                    </small>
                  )}
                </div>
                {/* Custom checkbox with icons */}
                {/* <div
                  className={`checkbox-icon ${
                    !item?.is_machine_status_level_set ? 'disabled' : ''
                  } ms-.2`}
                  onClick={() =>
                    item?.is_machine_status_level_set && handleItemClick(!isSelected, item)
                  }
                  style={{
                    cursor: item?.is_machine_status_level_set ? 'pointer' : 'not-allowed',
                    width: 22,
                    height: 24,
                    minWidth: 22,
                    borderRadius: 4,
                    backgroundColor: '#636363',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <FaCheck
                    size={14}
                    color={isSelected ? '#56b30b' : '#ffffff'} // green when selected, white when not
                  />
                </div> */}
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </div>
  );
};

export default AddMachineStatus;